import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, Box, Button, CircularProgress } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

// Sayfalar ve Bileşenler
import LoginPage from "./pages/LoginPage";
import AdminLayout from "./components/layout/AdminLayout";
import ProfileListPage from "./pages/admin/ProfileListPage";
import SondaListPage from "./pages/admin/SondaListPage";
import ProfileEditPage from "./pages/admin/ProfileEditPage";
import UserManagementPage from "./pages/admin/UserManagementPage";
import DailyReportPage from "./pages/admin/DailyReportPage";
import BulkEditPage from "./pages/admin/BulkEditPage";
import AdminJobs from "./pages/admin/AdminJobs";
import FieldAgentPage from "./pages/FieldAgentPage";
import SondajPage from "./pages/SondajPage";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import RegisterPage from "./pages/RegisterPage";
import TextureCalculatorPage from "./pages/TextureCalculatorPage";
import SondaEditPage from "./pages/admin/SondaEditPage";

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  // Uygulama yüklendiğinde ve auth_error event'i geldiğinde çalışacak
  useEffect(() => {
    const handleAuthError = () => {
      setUser(null);
    };

    window.addEventListener("auth_error", handleAuthError);

    const verifyUser = async () => {
      const savedUser = localStorage.getItem("fieldUser");
      const token = localStorage.getItem("fieldToken");

      if (savedUser && token) {
        try {
          setUser(JSON.parse(savedUser));
        } catch (error) {
          localStorage.removeItem("fieldUser");
          localStorage.removeItem("fieldToken");
        }
      }
      setAuthLoading(false);
    };

    verifyUser();

    return () => {
      window.removeEventListener("auth_error", handleAuthError);
    };
  }, []);

  // YÖNETİCİ KONTROLÜ (Sayfa yenilendiğinde de buradan geçer)
  const isManager =
    user?.role === "admin" ||
    user?.role === "project_coordinator" ||
    user?.role === "team_leader" ||
    user?.role === "auditor"; // Kontrol Mühendisi

  const handleSystemUpdate = () => {
    if (!navigator.onLine) {
      alert("Sistemi güncellemek için internet bağlantısı gereklidir!");
      return;
    }

    if (
      window.confirm(
        "Sistem güncellenecek ve sayfa yenilenecek. Kaydedilmemiş veriler kaybolabilir. Onaylıyor musunuz?",
      )
    ) {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (let registration of registrations) {
            registration.update();
          }
        });
      }
      window.location.reload(true);
    }
  };

  if (authLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <BrowserRouter>
      <CssBaseline />

      <Box
        sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Navbar user={user} setUser={setUser} />

        {/* Güncelleme Butonu */}
        <Box
          sx={{
            p: 1,
            display: "flex",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
          }}
        >
          <Button
            onClick={handleSystemUpdate}
            color="primary"
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
          >
            Sistemi Güncelle
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, py: 2 }}>
          <Routes>
            <Route path="/setup-admin-root" element={<RegisterPage />} />
            <Route path="/hg" element={<TextureCalculatorPage />} />

            {/* ANA SAYFA YÖNLENDİRMESİ */}
            <Route
              path="/"
              element={
                !user ? (
                  <LoginPage setUser={setUser} />
                ) : (
                  <Navigate
                    to={isManager ? "/admin/profiles" : "/field"}
                    replace
                  />
                )
              }
            />

            {/* YÖNETİCİ PANELİ (Admin, Koordinatör, Lider, Denetçi) */}
            <Route
              path="/admin"
              element={
                isManager ? <AdminLayout /> : <Navigate to="/" replace />
              }
            >
              <Route
                index
                element={<Navigate to="/admin/profiles" replace />}
              />
              <Route path="daily-report" element={<DailyReportPage />} />
              <Route path="profiles" element={<ProfileListPage />} />
              <Route path="sondas" element={<SondaListPage />} />
              <Route path="users" element={<UserManagementPage />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="bulk-edit" element={<BulkEditPage />} />
              <Route path="edit-profile/:id" element={<ProfileEditPage />} />
              <Route path="edit-sonda/:id" element={<SondaEditPage />} />
            </Route>

            {/* SAHA PERSONELİ PANELİ */}
            <Route
              path="/field"
              element={
                user && !isManager ? (
                  <FieldAgentPage user={user} />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route
              path="/field/sonda"
              element={
                user && !isManager ? (
                  <SondajPage user={user} />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
          </Routes>
        </Box>

        <Footer />
      </Box>
    </BrowserRouter>
  );
}

export default App;
